
import Router from '../src/shared/Router';
import './App.css';

function App() {
  return (
    <>

        <Router />

</>
      );
}

export default App;
